import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Typography,
} from '@mui/material'
import { CheckCircle, Cancel } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import { SecretCreationResult } from '@src/tools/key-vault/types/KeyVault'

interface ResultsTableProps {
  results: SecretCreationResult[]
  pendingKeys: string[]
}

const ResultsTable = ({ results, pendingKeys }: ResultsTableProps) => {
  const { t } = useTranslation()

  const allItems = [
    ...results.map((r) => ({ ...r, pending: false })),
    ...pendingKeys
      .filter((key) => !results.find((r) => r.secretName === key))
      .map((key) => ({ secretName: key, status: null, message: null, pending: true })),
  ]

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('keyVault.secretKey')}</TableCell>
            <TableCell>{t('common.status')}</TableCell>
            <TableCell>{t('keyVault.message')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allItems.map((item) => (
            <TableRow
              key={item.secretName}
              sx={(theme) => (item.status === 'Error' || item.status === 'AlreadyExists' ? { backgroundColor: theme.palette.mode === 'dark' ? 'rgba(244,67,54,0.1)' : 'rgba(244,67,54,0.05)' } : {})}
            >
              <TableCell>
                <Typography variant="monospaceData">
                  {item.secretName}
                </Typography>
              </TableCell>
              <TableCell>
                {item.pending ? (
                  <CircularProgress size={18} />
                ) : item.status === 'Success' ? (
                  <CheckCircle color="success" fontSize="small" />
                ) : (
                  <Cancel color="error" fontSize="small" />
                )}
              </TableCell>
              <TableCell>
                <Typography variant="body2" color={item.status === 'Success' ? 'text.secondary' : 'error'}>
                  {item.message ?? ''}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ResultsTable
